/**
 * Who may CHANGE the vehicle master, and who may only look at it.
 *
 * The vehicle master (makes, models, variants, fuel types, body types) is
 * global reference data owned by the country admin. It was also only VISIBLE
 * to the country admin -- the sidebar and the routes both required that role --
 * so a broker admin writing a motor policy could not look up the variant they
 * were being asked to name, even though every one of these endpoints has
 * allowed any authenticated user to read it all along:
 *
 *     def get_permissions(self):
 *         if self.action in ["list", "retrieve", "lookup"]:
 *             return [IsAuthenticated()]
 *         return [IsAuthenticated(), IsCountryAdmin()]
 *
 * So the gate was in the wrong place, and in only one of the two layers. This
 * puts the read where the server already had it, and keeps every write exactly
 * where the server enforces it -- a broker sees the data and no buttons that
 * would 403.
 */
import type { UserRole } from '@/types';

/** Roles the server will accept a write from. Mirrors `IsCountryAdmin`. */
const MASTER_DATA_EDITORS: UserRole[] = ['super_admin', 'country_admin'];

export function canManageVehicleMaster(role: UserRole | undefined): boolean {
  return !!role && MASTER_DATA_EDITORS.includes(role);
}
